import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { DashboardControllerModule } from './controllers/DashboardController';
import { DashboardUserView } from './user/user';

export const DashboardView = angular
  .module('acme.view.application.dashboard', [
    uiRouter,
    'ui.bootstrap',
    DashboardUserView,
    'acme.view.application.dashboard.admin',
    DashboardControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.dashboard',
      url: '/dashboard',
      views: {
        'subview-main': {
          controller: 'DashboardController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/dashboard/dashboard.tpl.html',
        },
      },
      data: {
        pageTitle: 'Dashboard',
        pageClass: 'application',
        roles: ['user', 'admin'],
      },
    });
  }).name;
